//@ts-nocheck
import { Fragment, useEffect, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { useAppDispatch } from "../../app/hooks";
import { createTeamsPayload } from "../../features/questionnaire/questionnaireTypes";
import { toast } from "sonner";
import {
  assignQuestionJobData,
  createLocation,
  fetchQuestionJobData,
  fetchQuestionList,
  updateLocation,
} from "../../features/questionnaire/questionnaireSlice";
import {
  ChevronDownIconWhite,
  CustomCheckIcon,
  ExclamationIcon,
} from "../icons";
import { useParams } from "react-router-dom";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CrossIcon } from "../icons/Icons";

interface BoardPageProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  editBoardData?: any;
  baseId: number;
  setEditBoardData: (value: any) => void;
}

const SelectionTabs: React.FC<SelectionTabsProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className="flex w-full gap-4 my-6">
      {options.map((option, index) => (
        <button
          key={index}
          type="button"
          onClick={() => {
            onChange(option.value);
            // If Clone tab is selected, trigger the API call
            if (option.value === "approval") {
              onChange(option.value);
              // You might want to call the API here or in the parent component
            } else {
              onChange(option.value);
            }
          }}
          className={`flex items-start gap-3 p-4 w-full rounded-lg border text-left transition-colors ${
            value === option.value
              ? "border-indigo-600 bg-indigo-50"
              : "border-gray-200 hover:bg-gray-50"
          }`}
        >
          <div className="text-indigo-600 mt-[2px]">{option.icon}</div>
          <div>
            <div className="font-medium text-gray-900">{option.title}</div>
            <div className="text-sm text-gray-500">{option.description}</div>
          </div>
        </button>
      ))}
    </div>
  );
};

const CreateJobQuestionnaire: React.FC<BoardPageProps> = ({
  isModalOpen,
  setIsModalOpen,
  editBoardData,
  baseId,
  setEditBoardData,
}) => {
  const [name, setName] = useState("");
  const [purpose, setPurpose] = useState("");
  const [color, setColor] = useState("bg-[#3b82f6]");
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState("");
  const [purposeError, setPurposeError] = useState("");
  const dispatch = useAppDispatch();
  const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
  const { jobId } = useParams<{ jobId: string }>();
  const [searchTerm, setSearchTerm] = useState(""); // Add searchTerm state here
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [createPipelineAssignLoadingSave, setCreatePipelineAssignLoadingSave] =
    useState(false);
  const [selectedTab, setSelectedTab] = useState("new");
  const [jobPipeline, setJobPipeline] = useState<any[]>([]);
  const [createPipelineLoading, setCreatePipelineLoading] = useState(false);
  const filteredPipelines = jobPipeline.filter((pipeline: any) =>
    pipeline.questionset_name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const tabOptions = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-square-rounded-plus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
          <path d="M15 12h-6" />
          <path d="M12 9v6" />
        </svg>
      ),
      title: "Create New",
      description: "Create new questionnaire",
      value: "new",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-copy-plus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path stroke="none" d="M0 0h24v24H0z" />
          <path d="M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
          <path d="M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
          <path d="M11 14h6" />
          <path d="M14 11v6" />
        </svg>
      ),
      title: "Clone",
      description: "Clone exiting questionnaire",
      value: "approval",
    },
  ];

  const onTemplateSelect = (template: any) => {
    setSelectedTemplate(template);
  };

  useEffect(() => {
    if (selectedTab === "approval") {
      // Call the API to fetch scorecard list
      const fetchScorecards = async () => {
        setCreatePipelineLoading(true);
        try {
          // Fetch data
          const baseResponse = await dispatch(fetchQuestionList(baseId));

          if (baseResponse?.payload) {
            setJobPipeline(baseResponse.payload.data);
          } else {
            setJobPipeline([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setJobPipeline([]);
          toast.error("Failed to fetch pipeline details");
        } finally {
          setCreatePipelineLoading(false);
        }
      };

      fetchScorecards();
    }
  }, [selectedTab, baseId, dispatch]);

  const colorList = [
    { name: "bg-[#3b82f6]" },
    { name: "bg-[#6b7280]" },
    { name: "bg-[#bfdbfe]" },
    { name: "bg-[#ec4899]" },
    { name: "bg-[#6366f1]" },
    { name: "bg-[#eab308]" },
    { name: "bg-[#22c55e]" },
    { name: "bg-[#06b6d4]" },
    { name: "bg-[#dc2626]" },
  ];

  // Load edit data when available
  useEffect(() => {
    if (editBoardData) {
      setName(editBoardData.questionset_name || "");
      setPurpose(editBoardData.questionset_description || "");
      setColor(`bg-[${editBoardData.questionset_colour}]` || "bg-[#3b82f6]");
      // setChecked(editBoardData.ai_check === 'yes');
    }
  }, [editBoardData]);

  useEffect(() => {
    const storedData = localStorage.getItem("baseQuestionnaireDataByJob");
    if (storedData) {
      setBaseTeamsData(JSON.parse(storedData));
    }
  }, []);

  const handleSave = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setNameError("");
    setPurposeError("");

    if (name.trim().length === 0) {
      setNameError("Name is required");
      setLoading(false);
      return;
    }

    // else if (purpose.trim().length === 0) {
    //     // setPurposeError("Description is required");
    //     setLoading(false);
    //     return;
    // }

    // const privacy = checked ? "yes" : "no";
    const colorValue = color.substring(
      color.indexOf("[#") + 1,
      color.indexOf("]"),
    );

    const payload: createTeamsPayload = {
      base_id: baseId,
      questionset_name: name,
      questionset_description: purpose,
      questionset_colour: colorValue,
      job_id: jobId,
      // ai_check: privacy
    };

    try {
      if (editBoardData) {
        // Update existing team
        const response = await dispatch(
          updateLocation({
            payload,
            userId: baseId,
            id: editBoardData.id,
          }),
        );

        if (response.meta.requestStatus === "fulfilled") {
          toast.success("Questionnaire updated successfully!");
        } else {
          const errorMessage =
            response?.payload?.data?.data?.error ||
            response.payload?.message ||
            response.payload?.data?.message ||
            response.error?.message ||
            "Failed to updated questionnaire.";
          toast.error(errorMessage);
        }
      } else {
        // Create new team
        const response = await dispatch(
          createLocation({ payload, userId: baseId }),
        );
        if (response.meta.requestStatus === "fulfilled") {
          toast.success("Questionnaire created successfully!");
        } else {
          const errorMessage =
            response?.payload?.data?.data?.error ||
            response.payload?.message ||
            response.payload?.data?.message ||
            response.error?.message ||
            "Failed to create questionnaire.";
          toast.error(errorMessage);
        }
      }

      setIsModalOpen(false);
      resetForm();

      // Fetch updated list
      const baseResponse = await dispatch(
        fetchQuestionJobData({
          baseId: Number(baseId),
          JobId: jobId,
        }),
      );
      if (baseResponse?.payload) {
        localStorage.setItem(
          "baseQuestionnaireDataByJob",
          JSON.stringify(baseResponse.payload),
        );
        window.dispatchEvent(
          new StorageEvent("storage", {
            key: "baseQuestionnaireDataByJob",
            newValue: JSON.stringify(baseResponse.payload),
          }),
        );
      }
    } catch (error) {
      console.error("Failed to save team:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setName("");
    setPurpose("");
    setColor("bg-[#3b82f6]");
    // setChecked(false);
    setEditBoardData(null);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "name") {
      setName(value);
      setNameError(value.trim().length === 0 ? "Name is required" : "");
    } else if (name === "purpose") {
      setPurpose(value);
      // setPurposeError(value.trim().length === 0 ? "Description is required" : "");
    }
  };

  const handleAssignPipeline = async () => {
    if (!baseId || !jobId || !selectedTemplate?.id) {
      toast.error("Invalid Base ID, Job ID, or questionnaire Template");
      return;
    }

    setCreatePipelineAssignLoadingSave(true);

    try {
      const response = await dispatch(
        assignQuestionJobData({
          baseId: parseInt(baseId, 10),
          userId: selectedTemplate.id,
          JobId: jobId,
        }),
      );

      if (response.meta.requestStatus === "fulfilled") {
        toast.success("questionnaire assigned successfully!");
        const baseResponse = await dispatch(
          fetchQuestionJobData({
            baseId: Number(baseId),
            JobId: jobId,
          }),
        );

        if (baseResponse?.payload) {
          localStorage.setItem(
            "baseQuestionnaireDataByJob",
            JSON.stringify(baseResponse.payload),
          );
          window.dispatchEvent(
            new StorageEvent("storage", {
              key: "baseQuestionnaireDataByJob",
              newValue: JSON.stringify(baseResponse.payload),
            }),
          );
        }
        // localStorage.setItem('baseQuestionnaireDataByJob', JSON.stringify(baseResponseData.payload));

        setIsModalOpen(false);
        setSelectedTemplate("");
      } else {
        throw new Error(response.payload || "Failed to assign questionnaire");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to assign questionnaire");
    } finally {
      setCreatePipelineAssignLoadingSave(false);
    }
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={setIsModalOpen}
      className="relative z-10"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 
               data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all
                    data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in 
                    sm:my-8 sm:w-full sm:max-w-[34rem] sm:p-4 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-[0px] top-[3px] hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={() => setIsModalOpen(false)}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <CrossIcon />
              </button>
            </div>
            <div className="flex flex-col gay-y-4">
              <DialogTitle
                as="h3"
                className="text-base font-medium text-gray-900"
              >
                Assign Questionnaire
              </DialogTitle>
              <div className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[8px]"></div>
              <SelectionTabs
                options={tabOptions}
                value={selectedTab}
                onChange={setSelectedTab}
              />

              {selectedTab === "approval" && (
                <div className="mt-[5px]">
                  <div className="mt-0">
                    {/* <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6 mt-1.5'>Template Name</label> */}
                    <input
                      type="text"
                      placeholder="Search Template"
                      value={searchTerm}
                      // onKeyDown={handleKeyPress}

                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="px-3 py-[10px] w-[100%] border mt-0 border-gray-200 border-solid  rounded-t-lg text-sm border-b-0 focus:outline-none focus:ring-0 focus:ring-gray-200 focus:border-gray-200"
                    />
                  </div>
                  <div className="overflow-x-hidden">
                    <table className="min-w-full divide-y divide-x divide-gray-200">
                      <tbody className="bg-white divide-y rounded-b-lg block divide-gray-200 border border-solid border-[#e5e7eb] overflow-y-auto max-h-[400px] h-full">
                        {createPipelineLoading ? (
                          <tr className="flex items-center justify-center">
                            <td colSpan={4} className="px-6 py-4 text-center">
                              <div className="flex items-center justify-center relative z-50">
                                <div className="simple-spinner-loader">
                                  <span></span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : filteredPipelines.length > 0 ? (
                          filteredPipelines.map(
                            (template: any, index: number) => {
                              return (
                                <tr
                                  key={index}
                                  onClick={() => onTemplateSelect(template)}
                                  className={`flex items-center px-2 pt-[6px] pb-[7px] cursor-pointer w-full ${selectedTemplate?.id === template.id ? "bg-indigo-50" : ""}`}
                                >
                                  <div>
                                    {template?.questionset_colour && (
                                      <div className="flex shrink-0 pr-0 mt-[0px]">
                                        <span
                                          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
                                          style={{
                                            backgroundColor:
                                              template?.questionset_colour,
                                          }}
                                        >
                                          {template.questionset_name[0]}
                                        </span>
                                      </div>
                                    )}
                                  </div>

                                  <div className="flex flex-col">
                                    <td
                                      className="px-4 pt-0 pb-[0px] text-[#1b1b1b] text-[13px] font-normal
                         whitespace-nowrap  overflow-hidden text-ellipsis w-[400px] capitalize"
                                    >
                                      {template.questionset_name}
                                    </td>
                                    {template.questionset_description && (
                                      <td className="px-4 pt-0 pb-0">
                                        <span className="text-[13px] text-[#5c5c5e]  rounded-md px-0 leading-4 capitalize line-clamp-1 max-w-[400px]">
                                          {template.questionset_description}
                                        </span>
                                      </td>
                                    )}
                                  </div>
                                </tr>
                              );
                            },
                          )
                        ) : (
                          <tr className="flex items-center justify-center">
                            <td
                              colSpan={4}
                              className="px-6 py-4 text-center text-sm text-gray-500"
                            >
                              <div className="w-full mt-5 flex justify-center items-center flex-col gap-y-3">
                                <ExclamationIcon />
                                <p className="text-[#0000007a] text-[13px]">
                                  No results found
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="flex items-center justify-end gap-[22px] pt-4 flex-wrap md:flex-nowrap lg:flex-nowrap">
                    <button
                      type="submit"
                      className="inline-flex items-center relative justify-center whitespace-nowrap rounded-md bg-indigo-600 font-medium leading-normal help-btn-setting text-[#fefeff] min-w-[32px] h-[32px] px-[14px] text-[0.8125rem]"
                      onClick={handleAssignPipeline}
                    >
                      <div className="flex items-center flex-row-reverse gap-[6px]">
                        {createPipelineAssignLoadingSave ? (
                          <div className="flex items-center  gap-[6px]">
                            Create
                            <div className="simple-spinner">
                              <span></span>
                            </div>
                          </div>
                        ) : (
                          "Create"
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              )}

              {selectedTab === "new" && (
                <form action="#" className="space-y-6 mt-0">
                  <div className="flex flex-col gap-y-2">
                    <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                      Name
                    </label>
                    <div className="relative">
                      <Menu as="div" className="flex items-center">
                        <Menu.Button className="absolute inset-y-0 left-0 flex items-center px-2">
                          <div
                            className={`h-6 w-6 rounded-full ${color} border flex justify-center items-center`}
                          >
                            <ChevronDownIconWhite />
                          </div>
                        </Menu.Button>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                            {colorList.map((value, index) => (
                              <div
                                onClick={() => setColor(value.name)}
                                key={index}
                                className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center cursor-pointer`}
                              >
                                {color === value.name && <CustomCheckIcon />}
                              </div>
                            ))}
                          </Menu.Items>
                        </Transition>
                        <input
                          id="name"
                          name="name"
                          type="text"
                          value={name}
                          onChange={handleInputChange}
                          placeholder="Enter Name"
                          className="w-full px-4 py-2 pl-10 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                        />
                      </Menu>
                    </div>
                    {nameError && (
                      <p className="text-sm text-red-600">{nameError}</p>
                    )}

                    <div className="flex flex-col gap-y-2 mt-1">
                      <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                        Description
                      </label>
                      <input
                        id="purpose"
                        name="purpose"
                        type="text"
                        value={purpose}
                        onChange={handleInputChange}
                        placeholder="Team description"
                        className="w-full px-4 py-2 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                      />
                      {purposeError && (
                        <p className="text-sm text-red-600">{purposeError}</p>
                      )}
                    </div>
                  </div>
                  <span className="border-b border-solid border-[#e3e3e3] mx-[-16px] px-[8px] block py-[6px]"></span>
                  <div className="!mt-4 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                    <button
                      type="button"
                      onClick={handleSave}
                      className=" inline-flex shrink-0  justify-center items-center gap-1 rounded-md bg-indigo-600 px-[14px] py-1 h-[32px] text-[13px] font-medium leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      {loading ? (
                        <div className="flex items-center  gap-[6px]">
                          Save
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsModalOpen(false)}
                      className="mt-3 inline-flex w-full justify-center items-center rounded-md bg-white px-[14px] py-2 text-[13px] h-[32px] font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default CreateJobQuestionnaire;
